import Parse from 'parse';

const ROUND_UP_LOADING = 'ROUND_UP_LIST_LOADING';
const ROUND_UP_LOADED = 'ROUND_UP_LIST_LOADED';
const ROUND_UP_ORG_DATA_SET = 'ROUND_UP_ORG_DATA_SET';

const init = {
  organizations: [],
  userOrg: {},
  loading: false
};

export default function reducer(state = init, action = {}) {
  switch (action.type) {
    case ROUND_UP_LOADING:
      return { ...state, loading: true };
    case ROUND_UP_LOADED:
      return {
        ...state,
        loading: false,
        roundUpOrgs: action.roundUp
      };
    case ROUND_UP_ORG_DATA_SET:
      return {
        ...state,
        userOrg: action.userOrg
      };
    default:
      return state;
  }
}

export const getUserRoundUpData = () => {
  return async dispatch => {
    let userOrg;
    try {
      const user = await Parse.User.current();
      if (user && user.attributes) {
        let roundUpEnabled = user.attributes.roundUpEnabled || false;
        let roundUpOrgId = user.attributes.roundUpOrgID || '';
        let roundUpAmount = user.attributes.roundUpAmount || 0;
        userOrg = {
          roundUpEnabled,
          roundUpOrgId,
          roundUpAmount
        };
        dispatch({ type: ROUND_UP_ORG_DATA_SET, userOrg });
      } else {
        userOrg = {
          roundUpEnabled: false,
          roundUpOrgId: '',
          roundUpAmount: 0
        };
        dispatch({
          type: ROUND_UP_ORG_DATA_SET,
          userOrg
        });
      }
    } catch (error) {
      userOrg = {
        roundUpEnabled: false,
        roundUpOrgId: '',
        roundUpAmount: 0
      };
      dispatch({
        type: ROUND_UP_ORG_DATA_SET,
        userOrg
      });
      /* eslint-disable no-console */
      console.log(error);
    }
    return userOrg;
  };
};
